import $ from 'jquery';
import { getCookieValue, getConfig } from './config';
import { getQueryParamValue, debug, loadScript } from './utils';

// Builds the GTM dataLayer and boots Bing UET (loads bat.js + fires pageLoad).
// Called ONLY from fireConversion(), so it runs on conversion pages only. In the
// old per-file build this lived inside each conversions/*.js and ran solely where
// that script was included; in the single bundle it must NOT run at module load,
// or Bing would fire on every page.
function bootstrapConversionTracking() {
  let viewedComplete = false;
  if (getCookieValue('viewedComplete') !== undefined) {
    viewedComplete = true;
  }

  // GTM data layer push
  const dataLayer = [{
    sID: getQueryParamValue('sID'),
    main_onum: getQueryParamValue('main_onum'),
    main_subtotal: getQueryParamValue('main_subtotal'),
    main_total: getQueryParamValue('main_total'),
    email: getQueryParamValue('cEmail'),
    v_id: getQueryParamValue('v_id'),
    banner_name: getQueryParamValue('banner_name'),
    engine: getQueryParamValue('engine'),
    cRef: getQueryParamValue('cRef'),
    ip: getQueryParamValue('ip'),
    ctx_offer_id: getQueryParamValue('ctx_offer_id'),
    viewedComplete,
  }];
  debug('conversion dataLayer', dataLayer); // NOTE: original never pushed this to window.dataLayer (inert); left as-is

  /** * BING UET ** */
  (function (w, d, t, r, u) {
    let f; let n; let
      i; w[u] = w[u] || [], f = function () { const o = { ti: '25014811' }; o.q = w[u], w[u] = new UET(o), w[u].push('pageLoad'); }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () { const s = this.readyState; s && s !== 'loaded' && s !== 'complete' || (f(), n.onload = n.onreadystatechange = null); }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i);
  }(window, document, 'script', '//bat.bing.com/bat.js', 'uetq'));
  /** * END ** */
}

// Fires the GTM dataLayer + Bing UET event that used to live in conversions/*.js.
// `type` replaces the per-file split: conversion|sale|pv|bpv|spv.
export function fireConversion(type) {
    bootstrapConversionTracking();
    window.uetq = window.uetq || [];
    switch (type) {
        case 'conversion':
            window.uetq.push('event', '', { revenue_value: getQueryParamValue('main_total'), currency: 'USD' });
            break;
        case 'sale': {
            window.uetq.push('event', 'sale', { event_label: 'apm' });
            // Campaigner sale postback (from postbacks/campaigner/sale-postback.js)
            loadScript('https://conversiontracking.campaigner.com/js.min.js');
            const cc_Amount = getQueryParamValue('main_total');
            const cc_ReferenceId = getQueryParamValue('main_onum');
            const cc_Category = getQueryParamValue('main_category');
            const cc_Description = getQueryParamValue('lp_url');
            ProcessPConversion();
            break;
        }
        case 'pv':
            window.uetq.push('event', 'indexpv', { event_label: 'apm' });
            break;
        case 'bpv':
            window.uetq.push('event', 'billingpv', { event_label: 'apm' });
            break;
        case 'spv':
            window.uetq.push('event', 'shippingpv', { event_label: 'apm' });
            break;
        default:
            break;
    }
}

export const firePostBack = (settings) => {
    const url = String(getConfig().redtrackURL || '').trim();
    if (!url) {
        console.warn('[konnektive-one] firePostBack: redtrackURL is not configured');
        return;
    }
    const callSettings = {
        url,
        method: 'GET',
        data: settings,
    };
    debug('RedTrack Setup: ', callSettings);
    $.ajax(callSettings)
        .done((data) => {
            debug('RedTrack Call Result: ', data);
        }).fail((jqXHR, textStatus, error) => {
            console.log(`Error on request ${callSettings.url} to RedTrack: `, textStatus, error);
            console.log('Working around with IMG');
            $('body').append(`<img src="${callSettings.url}" with="1" height="1" />`);
        });
};
